<script setup lang="ts">
import {Download01, File06} from "utruckin-icons";

const props = defineProps<{
  documentUrl: string,
  caption: string,
}>()

const handleClick = (event: any) => {
  event.stopPropagation()
  window.open(props.documentUrl, "_blank");
}

</script>

<template>
  <div class="f-ui-document">
    <div class="title">
      <div class="icon" @click="(e: any) => {handleClick(e)}">
        <File06 :size="16"></File06>
      </div>

      <span class="label">{{ caption }}</span>
    </div>
    <div class="action" @click="(e: any) => {handleClick(e)}">
      <Download01 :size="16"></Download01>
    </div>
  </div>
</template>

<style scoped lang="scss">
.f-ui-document {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .title {
    display: flex;
    align-items: center;
    gap: 8px;

    .icon {
      width: 38px;
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background: var(--color-bg-secondary);
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -150%;
        height: 100%;
        width: 150%;
      }
    }
  }

  .action {
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: var(--color-bg-secondary);
    border: 1px solid var(--color-border);
    color: var(--color-blue);
  }
}

</style>